/**
 * store 存储
 */

import Vue from 'vue'
import Vuex from 'vuex'

import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
/**
 * 使用
 * getters => this.$store.getters.userInfo
 * mutation => this.$store.commit('SET_USER_INFO', {})
 * action异步请求 await this.$store.dispatch('Login', 5)
 */
